import { createElement } from "react";

import style from "./Heading.module.css";

export interface HeadingProps extends React.HTMLProps<HTMLHeadingElement> {
  type: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}

/**
 * Heading is used to render headlines with consistent styling.
 * In order to have consistent headlines we have 3 options, component wrappers, global styles or repeating css.
 * This component implements the first pattern like material-ui or chackra-ui
 */
const Heading: React.FC<HeadingProps> = ({ type, children, className, ...props }) => {
  return createElement(
    type,
    { className: `${style.heading} ${className ? className : ""}`, ...props },
    children
  );
};

export default Heading;
